import { render, staticRenderFns } from "./HeroProductShowcase.vue?vue&type=template&id=edf9e708&scoped=true&"
import script from "./HeroProductShowcase.vue?vue&type=script&lang=js&"
export * from "./HeroProductShowcase.vue?vue&type=script&lang=js&"
import style0 from "./HeroProductShowcase.vue?vue&type=style&index=0&id=edf9e708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf9e708",
  null
  
)

export default component.exports